import { BaseFilter } from "./cim-substation.model";

export class PowerTransformerCrud {
    id?: number;
    name: string;
    rating: string;
    primaryWinding: string;
    secondaryWinding: string;
    parentClass: string;
    parentName: string;

    _menuOpen?: boolean = false;

    constructor(data?: any) {
        this.id = data?.id ?? null;
        this.name = data?.name ?? '';
        this.rating = data?.rating ?? '';
        this.primaryWinding = data?.primaryWinding ?? '';
        this.secondaryWinding = data?.secondaryWinding ?? '';
        this.parentClass = data?.primaryWinding ?? '';
        this.parentName = data?.parentName ?? '';
    }
}

export class SelectPowerTransformerDto {
    id?: number;
    name: string;
    baseVoltage: string;

    constructor(data?: any){
        this.id = data?.id ?? null;
        this.name = data?.name ?? ''; 
        this.baseVoltage = data?.baseVoltage ?? ''; 
    }
}

export class EditPowerTransformerDto{
    id: number | null;
    substationTemplateInstanceId: number | null;
    name: string;
    primaryWindingBaseVoltageId: number;
    secondaryWindingBaseVoltageId: number;
    assetRatingId: number | null;

    constructor(data?: any){
        this.id = data.id ?? null;
        this.substationTemplateInstanceId = data.substationTemplateInstanceId;
        this.name = data.name;
        this.primaryWindingBaseVoltageId = data.primaryWindingBaseVoltageId;
        this.secondaryWindingBaseVoltageId = data.secondaryWindingBaseVoltageId;
        this.assetRatingId = data.assetRatingId;
    }
}

export class PowerTransformerFilter extends BaseFilter {
    searchType: PowerTransformerSearchType = PowerTransformerSearchType.Name;
    substationTemplateIds: number[] = [];
    ratingIds: number[] = [];
}

export enum PowerTransformerSearchType {
    Name = 1,
    SubstationName = 2
}